'use client';
import styles from './styles.module.scss';

const SingleBarGraph = ({ title, percentFull, label, color }) => {
    const full = 628; // Full length of the bar
    const filled = full * (percentFull * 0.01); // Calculate the filled portion based on percentage

    return (
        <div className={`${styles.barGraphs__graph} ${color[0]}`}>
            <div className={`${styles.barGraphs__title} ${color[0]}`}>
                {title}
            </div>
            <svg width="640" height="60" viewBox="0 0 640 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect 
                    width={filled} 
                    height="60"  
                    className={`${styles.barGraphs__bar} ${color[0]}`} 
                    fill="#B81CB5"  
                    rx="30" 
                    ry="30" 
                    style={{
                        clipPath: filled < 60 ? 'none' : 'inset(0px 0px 0px 30px)',
                    }}
                />
                <text 
                    x={filled / 2} 
                    y="30" 
                    textAnchor="middle" 
                    dominantBaseline="middle" 
                    fontSize="24" 
                    fill="#FFFFFF" 
                    className={styles.barGraphs__text}
                >
                    {label}
                </text>                
            </svg>
        </div>
    );
}

export default SingleBarGraph;
